module.exports = __webpack_public_path__ + "img/Folded_Paper_oval-bg-landing.0c6bbfd1.png";